<template>
    <div>
        <b-row v-for="license in value" :key="license.id">
            <b-col>
                #{{license.licenseId}} with status {{license.status}} in state {{license.state}}, issued on {{license.dateIssued}}.  Other Jurisdiction: {{license.otherJurisdiction}}
            </b-col>
        </b-row>

        <b-row v-if="!value || value.length === 0">
            <b-col>
                <p>No other license provided.</p>
            </b-col>
        </b-row>
    </div>
</template>

<script>  
export default {
    props: {
        value: Array,
    },
}
</script>

<style>
</style>
